import {lory} from 'lory.js';

/** Class representing a carousel. */
export default class Carousel {
  /**
   * Create a carousel.
   * @param {object} options - The options object.
   */
  constructor(options = {}) {
    this.slider = false;
    this.interval = false;
    this.sliderElement = false;
    this.boundlisteners = {};
    // default settings
    const defaultSettings = {
      delay: 10000,
      querySelector: '.js_slider',
      // infinite: 1,
      rewind: true,
      enableMouseEvents: true,
      indicatorsSelector: '.teaser-slider--indicator',
      rewindOnResize: false
    };
    this.settings = Object.assign({}, defaultSettings, options);

    this.initialize();
    this.startInterval();
  }

  /**
   * Adjust the indicators css according to slider state.
   * @param sliderIndicators
   */
  updateIndicators() {
    const activeIndex = this.slider.returnIndex();
    const sliderIndicators = this.sliderElement.querySelectorAll(this.settings.indicatorsSelector);
    // remove all active classes on indicators
    for (let i = 0; i < sliderIndicators.length; i++) {
      sliderIndicators[i].className = sliderIndicators[i].className.replace(' is-active', '');
      // set active class to next slide indicator
      if (activeIndex === i) {
        sliderIndicators[i].className += ' is-active';
      }
    }
  }

  /**
   * Remove all the event listneres related to the slider
   */
  removeSliderEvents() {

    const sliderIndicators = this.sliderElement.querySelectorAll(this.settings.indicatorsSelector);

    for (let i = 0; i < sliderIndicators.length; i++) {
      this.unbindListener('click', sliderIndicators[i], i);
    }

    this.unbindListener('after.lory.slide', this.sliderElement);
    this.unbindListener('slider:stop', this.sliderElement);
    this.unbindListener('slider:start', this.sliderElement);
    this.unbindListener('slider:setup', this.sliderElement);
    this.unbindListener('cms.widget.initialized', this.sliderElement);
    this.unbindListener('cms.widget.write.reordered', this.sliderElement);
  }

  /**
   * start auto-slide
   */
  startInterval(evt) {

    const delay = evt && evt.detail && evt.detail.delay || this.settings.delay;

    if (this.interval || !delay) {
      return;
    }

    // interval for auto slide
    this.interval = setInterval(() => {
      // check if slider is being hovered
      if (this.slider && !this.sliderElement.parentElement.querySelector(':hover')) {
        this.slider.next();
      }
    }, delay);
  }

  /**
   * stop auto-slide
   */
  stopInterval() {
    clearInterval(this.interval);
    this.interval = false;
  }

  /**
   * event-handler for sliding to specific slide
   * @param e
   */
  goToSlide(e) {
    if (window.Cms) {
      window.Cms.setUiLocked(true);
    }
    
    // special case for IE <= 10, who doesn't know 'dataset'
    var slide = e.target.dataset && e.target.dataset.slideTo ||
      Array.find(e.target.attributes, a => {return a.name === 'data-slide-to';}).value;

    this.slider.slideTo(parseInt(e.target.dataset.slideTo));
    if (window.Cms) {
      window.Cms.setUiLocked(false);
    }
  }

  /**
   * Reinitialize everything
   */
  reInit(evt) {
    const offset = evt && evt.detail && evt.detail[0] || 0;
    const index = parseInt(this.slider.returnIndex()) + parseInt(offset);

    if (this.slider) {
      this.slider.destroy();
      this.removeSliderEvents();
    }

    this.initialize();
    this.slider.slideTo(index);
    this.updateIndicators();
  }

  /**
   * Bind a listener in a way so that it can be removed afterwards
   * @param evt
   * @param target
   * @param fnc
   * @param index
   */
  bindListener(evt, target, fnc, index = 0) {

    if (typeof this.boundlisteners[evt] === 'undefined') {
      this.boundlisteners[evt] = [];
    }

    target.addEventListener(evt, fnc);
    this.boundlisteners[evt][index] = fnc;
  }

  /**
   * Unbind listener
   * @param evt
   * @param target
   * @param index
   */
  unbindListener(evt, target, index = 0) {

    if (
      typeof this.boundlisteners[evt] === 'undefined' ||
      typeof this.boundlisteners[evt][index] === 'undefined' ||
      typeof target === 'undefined'
    ) {
      return;
    }

    target.removeEventListener(evt, this.boundlisteners[evt][index]);
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  /**
   * Initialize the carousel
   */
  initialize() {

    this.sliderElement = document.querySelector(this.settings.querySelector);

    if (!this.sliderElement) {
      return;
    }

    // creating slider
    this.slider = lory(this.sliderElement, this.settings);

    const sliderIndicators = this.sliderElement.querySelectorAll(this.settings.indicatorsSelector);

    // adding click event listeners to indicators
    for (let i = 0; i < sliderIndicators.length; i++) {
      this.bindListener('click', sliderIndicators[i], this.goToSlide.bind(this), i);
    }

    // adding before.lory.slide event listener to window to update indicators
    this.bindListener('after.lory.slide', this.sliderElement, this.updateIndicators.bind(this));

    // listening if sliding should be stopped
    this.bindListener('slider:stop', this.sliderElement, this.stopInterval.bind(this));

    // listening if sliding should be resume
    this.bindListener('slider:start', this.sliderElement, this.startInterval.bind(this));

    // specific cms events
    this.bindListener('cms.initialized.all', global.document, this.stopInterval.bind(this));
    this.bindListener('cms.initialized.all', global.document, this._jqueryInit.bind(this));
    this.bindListener('cms.widget.write.reordered', this.sliderElement, this.reInit.bind(this));

    window.addEventListener('resize', this._recalculateSlideSize.bind(this));
    this.observer = new MutationObserver(mutations => {
      if (mutations.length > 0) {
        this.slider.setup();
      }
    });

    this.observer.observe(this.sliderElement.querySelector('ul,[data-slides]'), {childList: true});
  }

  _jqueryInit(options) {
    const $ = options.detail.jQuery;
    if ($ && $.subscribe) {
      $.subscribe('cms.viewport.changed', this._recalculateSlideSize.bind(this));
    }
  }

  _recalculateSlideSize() {
    this.slider.reset();
  }

  observer = null;
}



// WEBPACK FOOTER //
// ./~/fcse-cms/Resources/public/js/Frontend/Component/Carousel.js